
import { Vue } from "vue-class-component";

export default class ClockV4 extends Vue {}
